import useDarkMode from "@fisch0920/use-dark-mode";
import { cn, HeroUIProvider } from "@heroui/react";
import { useEffect, useRef } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { HomeTeamProvider, useHomeTeam } from "./hooks/useHomeTeam";
import { ThemeProvider } from "./hooks/useTheme";

function bgImg(code: string) {
  const backgrounds: Record<string, string> = {
    CSP: "bg-[url('assets/img/csp-bg-light.png')] dark:bg-[url('assets/img/csp-bg.png')]",
    HNS: "bg-[url('assets/img/hns-bg-light.png')] dark:bg-[url('assets/img/hns-bg.png')]",
    DAD: "bg-[url('assets/img/dad-bg-light.png')] dark:bg-[url('assets/img/dad-bg.png')]",
    DSE: "bg-[url('assets/img/dse-light.png')] dark:bg-[url('assets/img/dse.png')]",
  };
  return (
    backgrounds[code] ??
    "bg-[url('assets/img/ogr-bg-light.png')] dark:bg-[url('assets/img/ogr-bg.png')]"
  );
}

function bgSize(code: string) {
  if (code === "HNS") {
    return "auto 125px";
  } else if (code === "DAD") {
    return "auto 250px";
  } else {
    return "auto 250px";
  }
}

export function AppLayout({ children }: { children: React.ReactNode }) {
  const { code } = useHomeTeam();

  return (
    <div
      style={{
        backgroundBlendMode: "multiply",
        backgroundSize: bgSize(code),
      }}
      className={cn(
        "font-orbitron",
        "flex",
        "min-h-screen",
        "flex-col",
        "bg-top",
        "bg-contain",
        "text-center",
        "text-black",
        "bg-[#ffffff]",
        "dark:bg-black/10",
        "dark:text-white",
        bgImg(code)
      )}
    >
      <Header />
      <div className="flex flex-grow flex-col items-center">{children}</div>
      <Footer />
    </div>
  );
}

export function App() {
  const navigate = useNavigate();
  const darkMode = useDarkMode(true, {
    classNameDark: "dark",
    classNameLight: "light",
  });

  useEffect(() => {
    const html = document.querySelector("html");
    if (html) {
      if (!darkMode.value) {
        html.classList.remove("dark");
      } else {
        html.classList.add("dark");
      }
    }
  }, [darkMode.value]);

  const themeRef = useRef<HTMLDivElement>(null);

  return (
    <HeroUIProvider navigate={navigate}>
      <HomeTeamProvider>
        <div id="theme-wrapper" ref={themeRef}>
          <ThemeProvider wrapper={themeRef}>
            <AppLayout>
              <Outlet />
            </AppLayout>
          </ThemeProvider>
        </div>
      </HomeTeamProvider>
    </HeroUIProvider>
  );
}
